import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { AddClientToCarrierRequestDTO, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class AddClientCommand extends IRequestCommand<
  IAddClientResponse,
  ErrorDetails,
  IAddClientParameters
> {
  constructor(carrierUserId: string) {
    super();
    this._commandType = CommandRequestType.POST;
    this._commandUrl = 'carriers/{carrierUserId}/clients';
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      carrierUserId
    );
  }
}

export interface IAddClientParameters
  extends AddClientToCarrierRequestDTO,
    ICommandParameters {}

export interface IAddClientResponse extends ICommandResponse {}
